import { TeamStatuses } from "./types";

export enum TeamPlayerRoles {
  CAPTAIN = 'captain',
  DEPUTY = 'deputy_captain',
  DEFAULT = 'default_player'
};

export const TEAM_STATUSES: TeamStatuses = {
  registered: 'registered',
  ready: 'ready',
  moderated: 'moderated',
  disqualified: 'disqualified',
} as const;

export const MAX_TEAM_SIZE = 10;
export const TEAMS_TAG = 'Teams';
export const ALL_TEAMS_ID = 'All';
